import cx from "classnames";

import { NumeriqueResponsableLabel } from "./NumeriqueResponsableLabel";
import { Socials } from "./Socials";

type NumeriqueLabelsAndSocialMediaProps = {
  className?: string;
};

export const NumeriqueLabelsAndSocialMedia = ({
  className,
}: NumeriqueLabelsAndSocialMediaProps) => (
  <div
    className={cx(
      "flex flex-col gap-6 items-center lg:gap-8 lg:items-start",
      className,
    )}
  >
    <Socials />
    <NumeriqueResponsableLabel />
  </div>
);
